module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_eight-11face6c38ee0b640a86d7c5564fa1fe.webp";